/**
 * React Query query for AI-powered consultas list.
 */
import { useQuery } from "@tanstack/react-query";
import { useSupabaseClient } from "@/lib/supabase";
import { queryKeys } from "@/lib/api/queryKeys";
import { cachePolicies } from "@/lib/api/cache-policies";
import { getConsultasAI } from "../api/getConsultasAI";

export function useConsultasAI() {
  const { client, isReady } = useSupabaseClient();
  return useQuery({
    queryKey: [...queryKeys.consultas.list({}), isReady],
    queryFn: () => getConsultasAI(client),
    enabled: isReady,
    staleTime: cachePolicies.consultas.list.staleTime,
    gcTime: cachePolicies.consultas.list.gcTime,
  });
}
